/**
 * Do not edit directly
 */

export default "PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTE3LjQ0LDIxLjI1SDIuNzVWNi41NkgxNC4wOVY1LjA2SDEuMjVWMjIuNzVIMTguOTRWOS45MUgxNy40NFYyMS4yNVogTTExLjE5LDEuMjVWMi43NUgyMC4xNkw4LjYsMTQuMzFMOS42NiwxNS4zN0wyMS4yNSwzLjc4VjEyLjgxSDIyLjc1VjEuMjVIMTEuMTlaIi8+PC9zdmc+";